<template><div class="bt-component" v-bind:time="timeupdate"><div class="wapper"><div class="dragg-sheet"><span></span><span></span></div>
        <div id="urlQrcode">
          <div class="hidding-pc" style="padding: 8px;">
            <p style="font-weight: 900;">Share app</p>
            <p onclick="urlQrcodeSlideToggle()" style="position: absolute;top: 8px;right: 15px;color: #e8441f;">
              Done
            </p>
          </div>
          <div class="center-div">
            <qrcode class="image-qrcode" v-bind:value="urlQrcode"></qrcode>
            <div class="font-weight-bold">Spinning is a gift</div>
            <div class="title-qrcode text-black-50 hidding-pc">
              Open this app by scanning the qr code with your phone's camera
            </div>
            <button onclick="shareLink()" class="btn btn-outline-danger hidding-pc">Share link</button>
          </div>
        </div>
      <div class="block-widget bt-1638593785304 " ddd="d" bt-type="blockColumnOnly"><div class="block-content"><div class="block-widget bt-1638594452391 " ddd="d" bt-type="blockImage" @click="click($event, 'dW5kZWZpbmVk')"><div class="block-content"><img src="https://static.botbanhang.vn/appon/sad-1573382625-1638593933.gif"></div></div><div class="block-widget bt-1638594464748 " ddd="d" bt-type="blockText" @click="click($event, 'dW5kZWZpbmVk')"><div class="block-content"><p>Chúc Bạn May Mắn Lần Sau</p></div></div><div class="block-widget bt-1638594508383 " ddd="d" bt-type="blockButton" v-on:dblclick="dbclickfn($event)" @click="click($event, 'W3siaWQiOjE2Mzg1OTczOTYzMDAsInR5cGUiOiJwYWdlIiwiZGF0YSI6ImhvbWUiLCJ0aW1lX291dCI6MCwiY29uZmlnIjp7IjAiOiJoIiwiMSI6Im8iLCIyIjoibSIsIjMiOiJlIn19XQ==')"><div class="block-content undefined">Chơi Tiếp</div></div></div></div></div></div></template><style scoped>body{width:100%;height:100%;overflow: hidden;line-height:1.5;}.app-on-home > .bt-component .wapper:first-child{padding:0!important;} .wapper{background-image: url('https://static.botbanhang.vn/appon/538f0366-8243-49cd-aff0-3c5db96ee0a7-1757393004787.jpg');background-size:cover;background-attachment:scroll;background-position:center center;background-repeat:repeat;-webkit-overflow-scrolling: touch;-webkit-overflow-scrolling-x: touch;}
      @media screen and (min-width: 320px) and (max-width: 767px){
        body{height:100vh;}

        .bt-1638593785304{ height:556px;width:420px;max-width: 420px!important;position:relative!important;background-color:#FFFFFF00;background:#FFFFFF00; }.bt-1638593785304 > .block-content{ font-family:Arial;border-radius:0px 0px 0px 0px;border-width:0px;border-top-width:0px;border-left-width:0px;border-right-width:0px;border-bottom-width:0px;border-color:rgba(0,0,0,0);border-style:none;padding-top:0px;padding-bottom:0px;padding-left:0px;padding-right:0px;color: rgb(82, 95, 127)!important;font-size:13px;color: rgb(82, 95, 127);min-height:556px;overflow: hidden; }.bt-1638593785304 p,.bt-1638593785304 h1,.bt-1638593785304 h2,.bt-1638593785304 h3,.bt-1638593785304 h4,.bt-1638593785304 h5,.bt-1638593785304 h6{ color: rgb(82, 95, 127)!important;font-size:13px;color: rgb(82, 95, 127); }.bt-1638594452391{ width:270px;left:75px;height:270px;top:187px; }.bt-1638594452391 > .block-content{ background-color:transparent;background:transparent;font-family:Arial;border-radius:0px 0px 0px 0px;border-width:0px;border-top-width:0px;border-left-width:0px;border-right-width:0px;border-bottom-width:0px;border-color:rgba(0,0,0,0);border-style:none;padding-top:0px;padding-bottom:0px;padding-left:0px;padding-right:0px;color: rgb(82, 95, 127)!important;font-size:13px;color: rgb(82, 95, 127); }.bt-1638594452391 p,.bt-1638594452391 h1,.bt-1638594452391 h2,.bt-1638594452391 h3,.bt-1638594452391 h4,.bt-1638594452391 h5,.bt-1638594452391 h6{ color: rgb(82, 95, 127)!important;font-size:13px;color: rgb(82, 95, 127); }.bt-1638594464748{ width:414px;left:8px;height:35px;top:128px; }.bt-1638594464748 > .block-content{ background-color:rgba(0,0,0,0);background:rgba(0,0,0,0);font-family:Arial;text-align:center;border-radius:0px 0px 0px 0px;border-width:0px;border-top-width:0px;border-left-width:0px;border-right-width:0px;border-bottom-width:0px;border-color:rgba(0,0,0,0);border-style:none;padding-top:0px;padding-bottom:0px;padding-left:0px;padding-right:0px;color: #FFFFFF;color: #FFFFFF!important;font-size:24px;font-weight:bold;color: #FFFFFF; }.bt-1638594464748 p,.bt-1638594464748 h1,.bt-1638594464748 h2,.bt-1638594464748 h3,.bt-1638594464748 h4,.bt-1638594464748 h5,.bt-1638594464748 h6{ color: #FFFFFF;color: #FFFFFF!important;font-size:24px;font-weight:bold;color: #FFFFFF; }.bt-1638594508383{ width:116px;left:152px;height:43px;top:499px; }.bt-1638594508383 > .block-content{ background-image: url('https://static.botbanhang.vn/appon/Asset%201-1617869450-1621008937.png');background-color: rgba(0,0,0,0);background-size:100%;background-attachment:scroll;background-position:left top;background-repeat:no-repeat;font-family:Arial;border-radius:0px 0px 0px 0px;border-width:0px;border-top-width:0px;border-left-width:0px;border-right-width:0px;border-bottom-width:0px;border-color:rgba(0,0,0,0);border-style:none;padding-top:0px;padding-bottom:0px;padding-left:0px;padding-right:0px;color: #FFFFFF!important;font-size:18px;color: #FFFFFF; }.bt-1638594508383 p,.bt-1638594508383 h1,.bt-1638594508383 h2,.bt-1638594508383 h3,.bt-1638594508383 h4,.bt-1638594508383 h5,.bt-1638594508383 h6{ color: #FFFFFF!important;font-size:18px;color: #FFFFFF; }
        .desktop-app{
          width:100%!important;
          height: 100%!important;
        }
        .bt-component{
          width: 100%!important;
        }
        .wapper{
          width: 100%!important;
        }
        .block-widget[bt-type="blockColumnOnly"]{
          width: 100%!important;
        }
        .block-widget[bt-type="blockColumnOnly"] > .block-content{
          width: 100%!important;
        }
        .block-widget[bt-type="blockList"]{
          width: 100%!important;
        }
        .block-widget[bt-type="blockList"] > .block-content{
          width: 100%;
        }
      }
      @media screen and (min-width: 768px) and (max-width: 959px){
        .bt-1638593785304{ height:556px;width:420px;max-width: 420px!important;position:relative!important;background-color:#FFFFFF00;background:#FFFFFF00; }.bt-1638593785304 > .block-content{ font-family:Arial;border-radius:0px 0px 0px 0px;border-width:0px;border-top-width:0px;border-left-width:0px;border-right-width:0px;border-bottom-width:0px;border-color:rgba(0,0,0,0);border-style:none;padding-top:0px;padding-bottom:0px;padding-left:0px;padding-right:0px;color: rgb(82, 95, 127)!important;font-size:13px;color: rgb(82, 95, 127);min-height:556px;overflow: hidden; }.bt-1638593785304 p,.bt-1638593785304 h1,.bt-1638593785304 h2,.bt-1638593785304 h3,.bt-1638593785304 h4,.bt-1638593785304 h5,.bt-1638593785304 h6{ color: rgb(82, 95, 127)!important;font-size:13px;color: rgb(82, 95, 127); }.bt-1638594452391{ width:270px;left:75px;height:270px;top:187px; }.bt-1638594452391 > .block-content{ background-color:transparent;background:transparent;font-family:Arial;border-radius:0px 0px 0px 0px;border-width:0px;border-top-width:0px;border-left-width:0px;border-right-width:0px;border-bottom-width:0px;border-color:rgba(0,0,0,0);border-style:none;padding-top:0px;padding-bottom:0px;padding-left:0px;padding-right:0px;color: rgb(82, 95, 127)!important;font-size:13px;color: rgb(82, 95, 127); }.bt-1638594452391 p,.bt-1638594452391 h1,.bt-1638594452391 h2,.bt-1638594452391 h3,.bt-1638594452391 h4,.bt-1638594452391 h5,.bt-1638594452391 h6{ color: rgb(82, 95, 127)!important;font-size:13px;color: rgb(82, 95, 127); }.bt-1638594464748{ width:414px;left:8px;height:35px;top:128px; }.bt-1638594464748 > .block-content{ background-color:rgba(0,0,0,0);background:rgba(0,0,0,0);font-family:Arial;text-align:center;border-radius:0px 0px 0px 0px;border-width:0px;border-top-width:0px;border-left-width:0px;border-right-width:0px;border-bottom-width:0px;border-color:rgba(0,0,0,0);border-style:none;padding-top:0px;padding-bottom:0px;padding-left:0px;padding-right:0px;color: #FFFFFF;color: #FFFFFF!important;font-size:24px;font-weight:bold;color: #FFFFFF; }.bt-1638594464748 p,.bt-1638594464748 h1,.bt-1638594464748 h2,.bt-1638594464748 h3,.bt-1638594464748 h4,.bt-1638594464748 h5,.bt-1638594464748 h6{ color: #FFFFFF;color: #FFFFFF!important;font-size:24px;font-weight:bold;color: #FFFFFF; }.bt-1638594508383{ width:116px;left:152px;height:43px;top:499px; }.bt-1638594508383 > .block-content{ background-image: url('https://static.botbanhang.vn/appon/Asset%201-1617869450-1621008937.png');background-color: rgba(0,0,0,0);background-size:100%;background-attachment:scroll;background-position:left top;background-repeat:no-repeat;font-family:Arial;border-radius:0px 0px 0px 0px;border-width:0px;border-top-width:0px;border-left-width:0px;border-right-width:0px;border-bottom-width:0px;border-color:rgba(0,0,0,0);border-style:none;padding-top:0px;padding-bottom:0px;padding-left:0px;padding-right:0px;color: #FFFFFF!important;font-size:18px;color: #FFFFFF; }.bt-1638594508383 p,.bt-1638594508383 h1,.bt-1638594508383 h2,.bt-1638594508383 h3,.bt-1638594508383 h4,.bt-1638594508383 h5,.bt-1638594508383 h6{ color: #FFFFFF!important;font-size:18px;color: #FFFFFF; }
      }
      @media screen and (min-width: 960px){
        .bt-1638593785304{ height:556px;width:420px;max-width: 420px!important;position:relative!important;background-color:#FFFFFF00;background:#FFFFFF00; }.bt-1638593785304 > .block-content{ font-family:Arial;border-radius:0px 0px 0px 0px;border-width:0px;border-top-width:0px;border-left-width:0px;border-right-width:0px;border-bottom-width:0px;border-color:rgba(0,0,0,0);border-style:none;padding-top:0px;padding-bottom:0px;padding-left:0px;padding-right:0px;color: rgb(82, 95, 127)!important;font-size:13px;color: rgb(82, 95, 127);min-height:556px;overflow: hidden; }.bt-1638593785304 p,.bt-1638593785304 h1,.bt-1638593785304 h2,.bt-1638593785304 h3,.bt-1638593785304 h4,.bt-1638593785304 h5,.bt-1638593785304 h6{ color: rgb(82, 95, 127)!important;font-size:13px;color: rgb(82, 95, 127); }.bt-1638594452391{ width:270px;left:75px;height:270px;top:187px; }.bt-1638594452391 > .block-content{ background-color:transparent;background:transparent;font-family:Arial;border-radius:0px 0px 0px 0px;border-width:0px;border-top-width:0px;border-left-width:0px;border-right-width:0px;border-bottom-width:0px;border-color:rgba(0,0,0,0);border-style:none;padding-top:0px;padding-bottom:0px;padding-left:0px;padding-right:0px;color: rgb(82, 95, 127)!important;font-size:13px;color: rgb(82, 95, 127); }.bt-1638594452391 p,.bt-1638594452391 h1,.bt-1638594452391 h2,.bt-1638594452391 h3,.bt-1638594452391 h4,.bt-1638594452391 h5,.bt-1638594452391 h6{ color: rgb(82, 95, 127)!important;font-size:13px;color: rgb(82, 95, 127); }.bt-1638594464748{ width:414px;left:8px;height:35px;top:128px; }.bt-1638594464748 > .block-content{ background-color:rgba(0,0,0,0);background:rgba(0,0,0,0);font-family:Arial;text-align:center;border-radius:0px 0px 0px 0px;border-width:0px;border-top-width:0px;border-left-width:0px;border-right-width:0px;border-bottom-width:0px;border-color:rgba(0,0,0,0);border-style:none;padding-top:0px;padding-bottom:0px;padding-left:0px;padding-right:0px;color: #FFFFFF;color: #FFFFFF!important;font-size:24px;font-weight:bold;color: #FFFFFF; }.bt-1638594464748 p,.bt-1638594464748 h1,.bt-1638594464748 h2,.bt-1638594464748 h3,.bt-1638594464748 h4,.bt-1638594464748 h5,.bt-1638594464748 h6{ color: #FFFFFF;color: #FFFFFF!important;font-size:24px;font-weight:bold;color: #FFFFFF; }.bt-1638594508383{ width:116px;left:152px;height:43px;top:499px; }.bt-1638594508383 > .block-content{ background-image: url('https://static.botbanhang.vn/appon/Asset%201-1617869450-1621008937.png');background-color: rgba(0,0,0,0);background-size:100%;background-attachment:scroll;background-position:left top;background-repeat:no-repeat;font-family:Arial;border-radius:0px 0px 0px 0px;border-width:0px;border-top-width:0px;border-left-width:0px;border-right-width:0px;border-bottom-width:0px;border-color:rgba(0,0,0,0);border-style:none;padding-top:0px;padding-bottom:0px;padding-left:0px;padding-right:0px;color: #FFFFFF!important;font-size:18px;color: #FFFFFF; }.bt-1638594508383 p,.bt-1638594508383 h1,.bt-1638594508383 h2,.bt-1638594508383 h3,.bt-1638594508383 h4,.bt-1638594508383 h5,.bt-1638594508383 h6{ color: #FFFFFF!important;font-size:18px;color: #FFFFFF; }
        .desktop-app{
          float: unset!important;
          height: 780px!important;
          overflow: hidden!important;
          margin: 0px auto!important;
          padding-top: 60px!important;
          background-size: 100%!important;
          background-repeat: no-repeat;
        }
      }
      @media (min-width: 960px){
        #urlQrcode{
          display:block;
        }
      }
      .page-popup .wapper{
        border-radius: 10px 10px 0 0;
      }
      .dragg-sheet{
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: .5rem;
        padding-bottom: 1rem;
        cursor: pointer;
      }
      .dragg-sheet span{
          display: block;
          height: 2px;
          width: 28px;
          margin-bottom: 2px;
          background-color: rgba(0,0,0,.3);
          border-radius: 2px;
      }
      @media screen and (max-width: 768px){
        #urlQrcode{
          display: none;
        }
      }
      @media screen and (min-width: 320px){
        #urlQrcode{
          z-index: 9999999999999;
          background: white;
        }
        #urlQrcode .center-div {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
    </style><script type="module" id="js-component-app">export default {
              data: function () {
                  return {
                      timeupdate: new Date().getTime(),
                      dataModelBU: [{name: "", data: []}],
                      actionClick: false,
                      urlQrcode: "https://app.appon.vn/6a16d652e81b18848682267f",
                      runslide: false,
                      touch_start: {x:0, y:0, move: false},
                      touch_move: {x: 0, y: 0},
                      item_start:{x:0},
                      showWatermark: "false",
                      uidUser: "",
                      testabc: "",
                      clickbt: 0,
                      idapp: "6a16d652e81b18848682267f",mid:"",timestamp: new Date().getTime(),}
              },
              methods: {
                  atou: function(str) {
                      return decodeURIComponent(escape(window.atob(str)));
                  },
                  runAction: function(val, cb) {
                    console.log("action start: ", val);
                    if (!val) {
                      return;
                    }
                    val.config = val.data;
                    var this_vue = this;
                    var timeout = val.time_out || 0;
                    switch (val.type) {
                      case "validate": 
                      setTimeout(function() {
                        try {
                          var status = this_vue.actionValidate(val.config);
                          if (!status) {
                            return false;
                          }
                          cb(null, val.config);
                        } catch (e) {
                          cb(e);
                        }
                      }, timeout);
                      break;
                      case "link":
                        setTimeout(function() {
                          try {
                            this_vue.actionLink(val.config, val.params);
                            cb(null, val.config);
                          } catch (e) {
                            cb(e);
                          }
                        }, timeout);
                        break;
                      case "page":
                        setTimeout(function() {
                          try {
                            this_vue.actionPage(val.config);
                            cb(null, val.config);
                          } catch (e) {
                            cb(e);
                          }
                        }, timeout);
                        break;
                      case "phone":
                        setTimeout(function() {
                          try {
                            this_vue.actionPhone(val.config);
                            cb(null, val.config);
                          } catch (e) {
                            cb(e);
                          }
                        }, timeout);
                        break;
                      case "email":
                        setTimeout(function() {
                          try {
                            this_vue.actionEmail(val.config);
                            cb(null, val.config);
                          } catch (e) {
                            cb(e);
                          }
                        }, timeout);
                        break;
                      case "position":
                          try {
                            setTimeout(function() {
                              this_vue.actionPosition(val.config);
                            }, timeout);
                            cb(null, val.config);
                          } catch (e) {
                            cb(e);
                          }
                        break;
                      case "model":
                        setTimeout(function() {
                          try {
                            this_vue.actionModel(
                              val.config.type,
                              val.config.key,
                              val.config.value_set_model,
                              val.config.type_set_value,
                              val.config.dataAppSelect
                            );
                            cb(null, val.config);
                          } catch (e) {
                            cb(e);
                          }
                        }, timeout);
                        break;
                      case "api":
                        try {
                          var dataHeader = {};
                          var data = {};
                          var dataParams = {};
                          var dataGet = "";
                          var arrBody = val.config.api_select.configs.body.valueNormal || [];
                          var arrParams = val.config.api_select.configs.params || [];
                          var arrHeader = val.config.api_select.configs.header || [];
                          var url = val.config.api_select.configs.url;
                          var urlCurent = this_vue.resetString(url);
                          var method = val.config.method;
                          var id = val.config.api_select.id;
                          var is_form = true;
                          var typeBd = val.config.api_select.configs.body.type;
                          var typeSend = "application/json";
                          if (arrBody && arrBody.length > 0) {
                            for(var i = 0; i < arrBody.length; i++) {
                              if (arrBody[i].key && arrBody[i].key.length > 0) {
                                if (arrBody[i].dataAppSelect && arrBody[i].dataAppSelect.useValue === "model") {
                                  data[arrBody[i].key] = this_vue.getDataModelValue(arrBody[i].dataAppSelect);
                                } else {
                                  data[arrBody[i].key] = this_vue.resetString(arrBody[i].value);
                                }
                              }
                            }
                          }
                          if (typeBd == "raw" && val.config.api_select.configs.body.valueRaw && val.config.api_select.configs.body.valueRaw.length > 0) {
                            var dataraw = this_vue.resetString(val.config.api_select.configs.body.valueRaw);
                            dataraw = dataraw.replace(/$model./g, "this_vue.");
                            var dataeval = "data = " + dataraw;
                            eval(dataeval);
                          }
                          for(var j = 0; j < arrParams.length; j++) {
                            if (arrParams[j].key && arrParams[j].key.length > 0) {
                              if (arrParams[j].key && arrParams[j].key.length > 0) {
                                var valueKey;
                                if (arrParams[j].dataAppSelect && arrParams[j].dataAppSelect.useValue === "model") {
                                  valueKey = this_vue.getDataModelValue(arrParams[j].dataAppSelect);
                                } else {
                                  valueKey = this_vue.resetString(arrParams[j].value);
                                }
                                dataParams[arrParams[j].key] = valueKey;
                                if (dataGet && dataGet.length > 0) {
                                  dataGet += "&" + arrParams[j].key+"=" + valueKey;
                                } else {
                                  dataGet += "?" + arrParams[j].key+"=" + valueKey;
                                }
                              }
                            }
                          }
                          for(var k = 0; k < arrHeader.length; k++) {
                            if (arrHeader[k].key && arrHeader[k].key.length > 0) {
                              if (arrHeader[k].dataAppSelect && arrHeader[k].dataAppSelect.useValue === "model") {
                                dataHeader[arrHeader[k].key] = this_vue.getDataModelValue(arrHeader[k].dataAppSelect);
                              } else {
                                dataHeader[arrHeader[k].key] = this_vue.resetString(arrHeader[k].value);
                              }
                            }
                          }
                          dataHeader['Content-Type'] = "application/json";
                          if (val.config.api_select.configs.body.type === "raw") {
                            is_form = false;
                            data = JSON.stringify(data);
                            //dataHeader['Content-Type'] = "raw";
                            typeSend = "raw";
                          }
                          if (val.config.security === "security") {
                            url = "https://security.appon.vn/v1/public/bu_send";
                            dataHeader.xapi = id;
                            dataHeader.xurl = urlCurent;
                          } else {
                            url = this_vue.resetString(url);
                          }
                          if (dataGet && dataGet.length > 0 && val.config.security != "security") {
                            url += dataGet;
                            urlCurent += dataGet;
                          }
                          if (val.config.security === "security") {
                            var time = new Date().getTime();
                            var dataHeaderSave = {
                              header: JSON.stringify(dataHeader),
                              body: JSON.stringify(data),
                              params: JSON.stringify(dataParams),
                              time: time,
                              typeSen: typeSend,
                              is_form: is_form,
                              url: urlCurent,
                              method: val.config.method,
                              mbot5: MD5(time + "" + JSON.stringify(dataHeader))
                            };
                            data = window.btoa(encodeURIComponent(JSON.stringify(dataHeaderSave)));
                            var part = data.slice(10, 23);
                            var string = '';
                            for(let i = 0; i < data.length; i++) {
                              string+= data[i];
                              if (i === 15 || i === data.length - 15) {
                                string+=part;
                              }
                            }
                            data = JSON.stringify({data: string});
                            method = "POST";
                            dataHeader = {"Content-Type": "application/json"};
                            dataParams = "";
                          } 
                          if (arrHeader && arrHeader.length > 0 && arrHeader[0] && arrHeader[0].key && arrHeader[0].key.length > 0) {
                            $.ajax({
                              method: method,
                              url: url,
                              headers: dataHeader,
                              "data": data
                            }).done(function(res) {
                              if (val.config.actionSuccess && val.config.actionSuccess.length > 0) {
                                var dataSuc = val.config.actionSuccess;
                                dataSuc.find(function(x) {
                                  x.res = res;
                                });
                                for (var i = 0; i < dataSuc.length; i++) {
                                  this_vue.functionSuccess(dataSuc[i], function(res, abc){});
                                  if (i == dataSuc.length - 1) {
                                    cb(null, res);
                                  } 
                                }
                              } else {
                                cb(null, res);
                              }
                            }).fail(function(err) {
                              if (val.config.actionError && val.config.actionError.length > 0) {
                                var dataSuc = val.config.actionError;
                                dataSuc.find(function(x) {
                                  x.err = err;
                                });
                                async.eachSeries(dataSuc, this_vue.functionError, function(err, result) {
                                  cb(null,err);
                                });
                              }
                              setTimeout(function() {
                                cb(null,err);
                              },1000);
                            })
                          } else {
                            $.ajax({
                              method: method,
                              url: url,
                              "data": data
                            }).done(function(res) {
                              if (val.config.actionSuccess && val.config.actionSuccess.length > 0) {
                                var dataSuc = val.config.actionSuccess;
                                dataSuc.find(function(x) {
                                  x.res = res;
                                });
                                for (var i = 0; i < dataSuc.length; i++) {
                                  this_vue.functionSuccess(dataSuc[i], function(res, abc){});
                                  if (i == dataSuc.length - 1) {
                                    cb(null, res);
                                  } 
                                }
                              } else {
                                cb(null, res);
                              }
                            }).fail(function(err) {
                              if (val.config.actionError && val.config.actionError.length > 0) {
                                var dataSuc = val.config.actionError;
                                dataSuc.find(function(x) {
                                  x.err = err;
                                });
                                async.eachSeries(dataSuc, this_vue.functionError, function(err, result) {
                                  cb(null,err);
                                });
                              }
                              setTimeout(function() {
                                cb(null,err);
                              },1000);
                            })
                          }
                          
                        } catch (e) {
                          cb(e);
                        }
                        break;
                      case "function":
                        setTimeout(function() {
                          try {
                            var func = "" + val.config + "()";
                            eval(func);
                            cb(null, true)
                          } catch (e) {
                            cb(e);
                          }
                        }, timeout);
                        break;
                      case "tracking":
                        setTimeout(function() {
                          try {
                            var func = "" + val.config + "()";
                            eval(func);
                            cb(null, true)
                          } catch (e) {
                            cb(e);
                          }
                        }, timeout);
                        break;
                      case "googleform":
                        try {
                          var data = {};
                          data.fvv = val.config.fvv;
                          data.draftResponse = val.config.draftResponse;
                          data.pageHistory = val.config.pageHistory;
                          data.fbzx = val.config.fbzx;
                          if (val.config.params && val.config.params.length > 0) {
                            for (var i = 0; i < val.config.params.length; i++) {
                              if (val.config.requireParams) {
                                if (this_vue[val.config.params[i].model] && this_vue[val.config.params[i].model].length > 0) {
                                }else {
                                  var mess = val.config.messager_require || "Please check value!";
                                  alert(mess);
                                  return false;
                                }
                              }
                              if (val.config.params[i].key === "timestamp") {
                                data[val.config.params[i].key] = new Date().getTime();
                              } else {
                                if (val.config.params[i].dataAppSelect && val.config.params[i].dataAppSelect.useValue === "model") {
                                  data[val.config.params[i].key] = this_vue.getDataModelValue(val.config.params[i].dataAppSelect);
                                } else {
                                  data[val.config.params[i].key] =
                                  this_vue[val.config.params[i].model];
                                }
                              }
                            }
                            $.ajax({
                              method: "POST",
                              url: "" + val.config.formResponse,
                              data: data
                            });
                          }
                          cb(null, val.config);
                        } catch (e) {
                          cb(null, val.config);
                        }
                        break;
                    }
                  },
                  actionValidate: function(val){
                    if (val && val.length > 0) {
                      for(var i = 0; i < val.length; i++) {
                        var mess = val[i].mess || "please check value!";
                        if (val[i].dataAppSelect && val[i].dataAppSelect.useValue === "model") {
                          var value = this.getDataModelValue(val[i].dataAppSelect);
                          if (val[i].type === "empty" && (!value || $.trim(value).length <= 0)) {
                            alert(mess);
                            return false;
                          }
                          var syntax = new RegExp(val[i].syntax);
                            if (val[i].type === "syntax" && !syntax.test(value)) {
                              alert(mess);
                              return false;
                            }
                        } else {
                          var key = val[i].model;
                          if (key && key.length > 0) {
                            var value = this[key];
                            if (val[i].type === "empty" && !this[key]) {
                              alert(mess);
                              return false;
                            }
                            var syntax = new RegExp(val[i].syntax);
                            if (val[i].type === "syntax" && !syntax.test(this[key])) {
                              alert(mess);
                              return false;
                            }
                          }
                        }
                      }
                    }
                    return true;
                  },
                  functionSuccess: function(val, cb) {
                    var this_vue = this;
                    switch (val.type) {
                        case "link":
                            try {
                              this_vue.actionLink(val.value_action);
                              cb(null, val.value_action);
                            } catch (e) {
                              cb(e);
                            }
                            break;
                        case "page":
                            try {
                              this_vue.actionPage(val.value_action);
                              cb(null, val.value_action);
                            } catch (e) {
                              cb(e);
                            }
                            break;
                        case "phone":
                            try {
                              this_vue.actionPhone(val.value_action);
                              cb(null, val.value_action);
                            } catch (e) {
                              cb(e);
                            }
                            break;
                        case "email":
                            try {
                              this_vue.actionEmail(val.value_action);
                              cb(null, val.value_action);
                            } catch (e) {
                              cb(e);
                            }
                            break;
                        case "position":
                            try {
                              this_vue.actionPosition(val.value_action);
                              cb(null, val.value_action);
                            } catch (e) {
                              cb(e);
                            }
                            break;
                        case "model":
                          try{
                            var value = "";
                            if (val.value_action.trim().search("res") == 0) {
                              var str = "value = val." + val.value_action + ";";
                              eval(str);
                            } else {
                                value = val.value_action;
                            }
                            this_vue.actionModel("", val.value_type, value, val.type_set_value, val.dataAppSelect);
                            cb(null, val.value_action);
                          }catch (e) {
                            cb(e);
                          }
                          
                        break;
                        case "tracking":
                            try {
                              var func = "" + val.value_action + "()";
                              eval(func);
                              cb(null, true)
                            } catch (e) {
                              cb(e);
                            }
                        break;
                        case "function":
                            try {
                              var func = "" + val.value_action + "()";
                              eval(func);
                              cb(null, true)
                            } catch (e) {
                              cb(e);
                            }
                        break;
                      }
                  },
                  functionError: function(val, cb) {
                    var this_vue = this;
                    switch (val.type) {
                        case "link":
                            this_vue.actionLink(val.value_action);
                            cb(null, val.value_action);
                            break;
                        case "page":
                            this_vue.actionPage(val.value_action);
                            cb(null, val.value_action);
                            break;
                        case "phone":
                            this_vue.actionPhone(val.value_action);
                            cb(null, val.value_action);
                            break;
                        case "email":
                            this_vue.actionEmail(val.value_action);
                            cb(null, val.value_action);
                            break;
                        case "position":
                            this_vue.actionPosition(val.value_action);
                            cb(null, val.value_action);
                            break;
                        case "model":
                          try{
                            var value = "";
                            value = val;
                            if (val.value_type && val.value_action && val.value_action.trim().search("err") == 0) {
                              var str = "value = val." + val.value_action;
                              eval(str);
                            } else {
                                value = val.value_action;
                            }
                            this_vue.actionModel("", val.value_type, value, val.type_set_value, val.dataAppSelect);
                            cb(null, val.value_action);
                          }catch (e) {
                              cb(e);
                          }
                            break;
                        case "tracking":
                            try {
                              var func = "" + val.value_action + "()";
                              eval(func);
                              cb(null, true)
                            } catch (e) {
                              cb(e);
                            }
                        break;
                        case "function":
                            try {
                              var func = "" + val.value_action + "()";
                              eval(func);
                              cb(null, true)
                            } catch (e) {
                              cb(e);
                            }
                        break;
                      }
                  },
                  actionLink: function(link, params) {
                    var datalink = link;
                    if (params && params.length > 0) {
                      for(var i = 0; i < params.length; i++) {
                        if (i == 0) {
                          datalink += "?" + params[i].key + "=" + this.getDataModelValue(params[i].dataAppSelect);
                        } else {
                          datalink += "&" + params[i].key + "=" + this.getDataModelValue(params[i].dataAppSelect);
                        }
                      }
                    }
                    var linkaction = this.resetString(datalink);
                    var action = document.createElement("a");
                    action.setAttribute("href", linkaction);
                    action.setAttribute("target", "_blank");
                    action.click();
                    action.remove();
                  },
                  actionEmail: function(email) {
                    var action = "mailto:" + this.resetString(email);
                    var email = document.createElement("a");
                    email.setAttribute("href", action);
                    email.setAttribute("target", "_top");
                    email.click();
                    email.remove();
                  },
                  actionPhone: function(phone) {
                    var action = "tel:" + this.resetString(phone);
                    var phone = document.createElement("a");
                    phone.setAttribute("href", action);
                    phone.click();
                     phone.remove();
                  },
                  actionPosition: function(position) {
                    var wg = $(".page-popup ." + position);
                    var scTop = $(".page-popup .wapper").scrollTop();
                    if (wg.attr("bt-type") == "blockLightBox") {
                      wg.css({"display":"flex"});
                    } else {
                      var top = wg.offset().top + scTop;
                      $(".page-popup .wapper").animate({
                        scrollTop: top
                      },500);
                    }
                  },
                  setValueDataList: function(value, dataAppSelect) {
                  },
                  actionModel: function(type, key, value, type_set_value, dataAppSelect) {
                    var val = "";
                    var valuesetModel;
                    if (typeof value === "string") {
                      val = value.trim();
                    }
                    if (val && val != "" && val.length > 4 && val.search("{{") >= 0) {
                      valuesetModel = this.resetString(val);
                    } else {
                      if (type === "number") {
                        valuesetModel = parseFloat(value);
                      } else {
                        valuesetModel = value;
                      }
                    }
                    var thisVue = this;
                    valuesetModel = thisVue.resetString(valuesetModel);
                    switch(type_set_value) {
                      case "length":
                        if (dataAppSelect && dataAppSelect.useValue === "model") {
                          thisVue.sm(dataAppSelect.nameTab, dataAppSelect.keySelect, dataAppSelect.indexKey, valuesetModel.length);
                        } else {
                          thisVue[key] = valuesetModel.length;
                        }
                        break;
                      case "assign":
                        if (dataAppSelect && dataAppSelect.useValue == "model") {
                          thisVue.sm(dataAppSelect.nameTab, dataAppSelect.keySelect, dataAppSelect.indexKey, valuesetModel);
                        }else {
                          thisVue[key] = valuesetModel;
                        }
                        break;
                      case "concat":
                          if (Array.isArray(valuesetModel) && valuesetModel.length > 0) {
                            try {
                              for(var i = 0; i < valuesetModel.length; i++) {
                                if (dataAppSelect && dataAppSelect.useValue === "model") {
                                  thisVue.sm(dataAppSelect.nameTab, dataAppSelect.keySelect, dataAppSelect.indexKey, valuesetModel);
                                }else {
                                  thisVue[key].push(valuesetModel[i]);
                                }                              
                              }
                            } catch(e) {
                            }
                          } else {
                            if (dataAppSelect && dataAppSelect.useValue === "model") {
                              thisVue.sm(dataAppSelect.nameTab, dataAppSelect.keySelect, dataAppSelect.indexKey, valuesetModel);
                            }else {
                              thisVue[key].push(valuesetModel);
                            }                          
                          }
                        break;
                      default:
                        if (dataAppSelect && dataAppSelect.useValue === "model") {
                          thisVue.sm(dataAppSelect.nameTab, dataAppSelect.keySelect, dataAppSelect.indexKey, valuesetModel);
                        } else {
                          thisVue[key] = valuesetModel;
                        }
                        break;
                    }
                    // var data = JSON.parse(this.budcodedata(localStorage.getItem("botup-model")));
                    // data["dataModelBU"] = $.extend(true, [], this.dataModelBU);
                    // localStorage.setItem("botup-model", this.buecodedata(JSON.stringify(data)));
                  },
                  actionPage: function(page) {
                    var wgHome = $(".app-on-home");
                    if (wgHome && wgHome.length > 0) {
                      var data = {mid:this.mid,timestamp:this.timestamp,};
                      data["dataModelBU"] = $.extend(true, [], this.dataModelBU);
                      data.bu_appID = '6a16d652e81b18848682267f';
                      localStorage.setItem("botup-model", this.buecodedata(JSON.stringify(data)));
                      this.$emit("actionPage", page);
                    } else {
                      this.$router.push({"name": page});
                    }
                  },
                  dbclickfn: function(event) {
                    event.stopPropagation();
                    event.preventDefault();
                    return false;
                  },
                  click: function (event, val) {
                    //event.stopPropagation();
                    //event.preventDefault();
                    var thisVue = this;
                    if (thisVue.atou(val) && thisVue.atou(val) != undefined && thisVue.atou(val) != "undefined") {
                      var val = JSON.parse(thisVue.atou(val));      
                      if (thisVue.clickbt == 0) {
                        thisVue.clickbt = 1;
                        async.eachSeries(val, thisVue.runAction, function(err, result) {
                          thisVue.clickbt = 0;
                        });
                        thisVue.clickbt = 0;
                      }
                    }
                  },
                  sliderLeftimg: function(event, id) {
                    var wgSlider = $("."+id);
                    var col = wgSlider.find(".list-img").attr("data-col");
                    var indexSl = parseFloat(wgSlider.find(".img-show").attr("data-sl"));
                    var listItem = wgSlider.find(".list-img img");
                    listItem.removeClass("bounceInLeft").addClass("bounceInRight").hide();
                    listItem.each(function() {
                      if (parseFloat(wgSlider.find(".img-show").attr("data-sl")) <= parseFloat($(this).attr("data-show")) && parseFloat($(this).attr("data-show")) < parseFloat(col) + indexSl) {
                        $(this).show();
                      }
                    })
                    indexSl = indexSl + parseFloat(col);
                    if (indexSl >= listItem.length) {
                      indexSl = 0;
                    }
                    wgSlider.find(".img-show").attr({
                      "data-sl": indexSl,
                      "src": listItem.eq(indexSl).attr("src")
                    });
                  },
                  sliderRightimg: function(event, id) {
                    var wgSlider = $("."+id);
                    var col = wgSlider.find(".list-img").attr("data-col");
                    var indexSl = parseFloat(wgSlider.find(".img-show").attr("data-sl"));
                    var listItem = wgSlider.find(".list-img img");
                    listItem.removeClass("bounceInRight").addClass("bounceInLeft").hide();
                    listItem.each(function() {
                      if (parseFloat(wgSlider.find(".img-show").attr("data-sl")) <= parseFloat($(this).attr("data-show")) && parseFloat($(this).attr("data-show")) < parseFloat(col) + indexSl) {
                        $(this).show();
                      }
                    })
                    indexSl = indexSl + parseFloat(col);
                    if (indexSl >= listItem.length) {
                      indexSl = 0;
                    }
                    wgSlider.find(".img-show").attr({
                      "data-sl": indexSl,
                      "src": listItem.eq(indexSl).attr("src")
                    });
  
                  },
                  runSliderimg: function() {
                    var wgSlide = $('.block-widget[bt-type="blockSlider"]');
                    var thisVue = this;
                    if (wgSlide && wgSlide.length > 0) {
                      wgSlide.each(function() {
                        thisVue.runItemSliderImg($(this));
                      });
                    }
                  },
                  runItemSliderImg: function(wgSlider) {
                    var thisVue = this;
                    var col = wgSlider.find(".list-img").attr("data-col");
                    var indexSl = parseFloat(wgSlider.find(".img-show").attr("data-sl"));
                    var listItem = wgSlider.find(".list-img img");
                    // click item img
                    if (listItem && listItem.length > 0) {
                      listItem.css({"width": (100/parseFloat(col))+"%"}).hide();
                      listItem.each(function() {
                        if (parseFloat($(this).attr("data-show")) < parseFloat(col) + indexSl) {
                          $(this).show();
                        }
                      });
                      indexSl = indexSl + parseFloat(col);
                      wgSlider.find(".img-show").attr({
                        "data-sl": indexSl,
                        "src": listItem.eq(indexSl).attr("src")
                      });
  
                      listItem.off("click").on("click", function() {
                        var $this = $(this);
                        listItem.removeClass("active");
                        $this.addClass("active");
                        wgSlider.find(".img-show").attr({
                          "data-sl": $this.attr("data-show"),
                          "src": $this.attr("src")
                        });
                      });
  
                      thisVue.setInterValSlider(wgSlider, col, listItem, indexSl);
                      wgSlider.off("mouseenter").on("mouseenter", function() {
                        clearInterval(thisVue[""+wgSlider.attr("data-id")]);
                      });
                      wgSlider.off("mouseleave").on("mouseleave", function() {
                        listItem.removeClass("bounceInLeft").addClass("bounceInRight");
                        thisVue.setInterValSlider(wgSlider, col, listItem, indexSl);
                      })
                    }
                  },
                  setInterValSlider: function(wgSlider, col, listItem, indexSl) {
                    var thisVue = this;
                    thisVue[""+wgSlider.attr("data-id")] = setInterval(function() {
                      var indexSl = parseFloat(wgSlider.find(".img-show").attr("data-sl"));
                      if (parseFloat(indexSl) < listItem.length) {
                        listItem.removeClass("active").hide();
                        listItem.eq(indexSl).addClass("active");
                        var total = parseFloat(col) + indexSl;
                        listItem.each(function() {
                          if (parseFloat(wgSlider.find(".img-show").attr("data-sl")) <= parseFloat($(this).attr("data-show")) && parseFloat($(this).attr("data-show")) < parseFloat(col) + indexSl) {
                            $(this).show();
                          }
                        })
                        indexSl = indexSl + parseFloat(col);
                        if (indexSl >= listItem.length) {
                          indexSl = 0;
                        }
                        wgSlider.find(".img-show").attr({
                          "data-sl": indexSl,
                          "src": listItem.eq(indexSl).attr("src")
                        });
                      } else {
                        indexSl = 0;
                        wgSlider.find(".img-show").attr({
                          "data-sl": indexSl,
                          "src": listItem.eq(indexSl).attr("src")
                        });
                        listItem.removeClass("active").hide();
                        listItem.eq(indexSl).addClass("active");
                        listItem.each(function() {
                          if (indexSl <= parseFloat($(this).attr("data-show")) && parseFloat($(this).attr("data-show")) < parseFloat(col) + indexSl) {
                            $(this).show();
                          }
                        })
                      }
                    }, 5000);
                  },
                  sliderLeft: function(event, id) {
                    var thisVue = this;
                    if (!this.runslide) {
                      this.runslide = true;
                      var itemFirst = $("."+id+" > .block-content").eq(0);
                      var listitem = $("."+id+" > .block-content");
                      var left = parseFloat(itemFirst.css("margin-left"));
                      var index = Math.round(left / itemFirst.outerWidth());
                      if (index < 0) {
                        var marginLeft = (index + 1) * itemFirst.outerWidth();
                        itemFirst.animate({
                          "margin-left": marginLeft + "px"
                        }, 300);
                        setTimeout(function() {
                          thisVue.runslide = false;
                        });
                      } else {
                        thisVue.runslide = false;
                      }
                    }
                  },
                  sliderRight: function(event, id) {
                    var thisVue = this;
                    if (!this.runslide) {
                      this.runslide = true;
                      var itemFirst = $("."+id+" > .block-content").eq(0);
                      var listitem = $("."+id+" > .block-content");
                      var left = parseFloat(itemFirst.css("margin-left"));
                      var index = Math.round(left / itemFirst.outerWidth());
                      if (0 - index < listitem.length - 1) {
                        var marginLeft = (index - 1) * itemFirst.outerWidth();
                        itemFirst.animate({
                          "margin-left": marginLeft + "px"
                        }, 300);
                        setTimeout(function() {
                          thisVue.runslide = false;
                        });
                      } else {
                        thisVue.runslide = false;
                      }
                    }
                  },
                  touchstart: function(event, id) {
                    var touch = event.touches[0];
                    this.touch_start.x = touch.pageX;
                    this.touch_start.y = touch.pageY;
                    var itemFirst = $("."+id+" > .block-content").eq(0);
                    this.item_start.x = parseFloat(itemFirst.css("margin-left"));
                  },
                  touchmove: function(event, id) {
                    this.touch_start.move = "true";
                    var touch = event.touches[0];
                    this.touch_move.x = touch.pageX;
                    this.touch_move.y = touch.pageY;
                    var itemFirst = $("."+id+" > .block-content").eq(0);
                    var marg = this.touch_move.x - this.touch_start.x + this.item_start.x;
                    itemFirst.css({
                      "margin-left": marg + "px"
                    });
                  },
                  touchend: function(event, id) {
                    var touch = event.touches[0];
                    if (this.touch_start.move === "true") {
                      var itemFirst = $("."+id+" > .block-content").eq(0);
                      var marg = parseFloat(itemFirst.css("margin-left"));
                      if(marg > 0) {marg = 0};
                      itemFirst.css({
                        "margin-left": marg + "px"
                      });
  
                      var numItem = $("."+id+" > .block-content").length;
                      if((320 - marg - numItem * parseFloat(itemFirst.outerWidth())) > 10) {
                        marg = 320 - numItem * parseFloat(itemFirst.outerWidth());
                        itemFirst.css({
                          "margin-left": marg + "px"
                        });
                      }
                      this.touch_start.move = false;
                    }
                  },
                  blurInput: function(event, require, mess) {
                    var error = mess || "Please check value!";
                    var value = $(event.target).val();
                    var type = $(event.target).attr("type");
                    var pattern = $(event.target).attr("pattern");
                    if (require && (!pattern || pattern.length <= 0)) {
                      switch(type) {
                        case "text":
                          if (!value || value.length === 0) {
                            alert(error);
                          }
                        break;
                        case "email":
                          if (value && value.length > 0 && value.search("@") > 0 && value.search("@") != (value.length -1)) {
  
                          } else {
                            alert(error);
                            // event.target.setCustomValidity(error);
                          }
                        break;
                        case "phone":
                          if(value && value.length > 0) {
  
                          } else {
                            alert(error);
                            //event.target.setCustomValidity(error);
                          }
                        break;
                        case "number":
                          if (parseFloat(value)) {
  
                          } else {
                            alert(error);
                            //event.target.setCustomValidity(error);
                          }
                        break;
                        default:
                            if (!value || value.length === 0) {
                              alert(error);
                              //event.target.setCustomValidity(error);
                            }
                          break;
                      }
                    } else {
                      if (pattern && pattern.length > 0 && require) {
                        var reg = new RegExp(pattern);
                        if (!reg.test(value)) {
                          alert(error);
                        }
                      }
                    }
                  },
                  resetString: function(str){
                    if (typeof str == 'string' && str.search("{{") >= 0) {
                      var arr = str.split("{{");
                      var arrMo = [];
                      for(var i = 0; i< arr.length; i++) {
                        if(arr[i].search("}}") != -1) {
                          arrMo.push(arr[i].split("}}")[0]);
                        }
                      }
                      for(var j = 0; j < arrMo.length; j++) {
                        var val = arrMo[j];
  
                        if (val.search(".") != 0 && val.search(".") != -1) {
                          var child = val.split(".");
                          var values = this[child[0]];
                          for (var n = 1; n < child.length; n++) {
                            values = values[child[n]];
                            if (n === (child.length -1) && typeof values === "object") {
                              var stringconvert = JSON.stringify(values);
                              str = str.replace("{{" + arrMo[j] + "}}", stringconvert);
                            }
                          }
                          str = str.replace("{{" + arrMo[j] + "}}", values);
                        } else {
                          if (typeof this[val] === "object") {
                            var stringconvert = JSON.stringify(this[val]);
                            str = str.replace("{{" + arrMo[j] + "}}", stringconvert);
                          } else {
                            var valeval = eval("this."+val);
                            if(typeof valeval == "object") {
                              str = valeval;
                            } else{
                              str = str.replace("{{" + arrMo[j] + "}}", eval("this."+val));
                            }
                          }
                        }
                        if(typeof str != "object") { 
                          str = str.replace("[[", "[");
                          str = str.replace("]]", "]");
                        }
                      }
                      return str;
                    } else {
                      return str;
                    }
                  },
                  resetSticky: function(wg) {
                      if (wg && wg.length > 0) {
                        if ($("body").outerWidth() > 768) {
                          var left = parseFloat(wg.css("left"));
                          var leftBody = $(".page-popup .bt-component").offset().left;
                          var top = parseFloat(wg.css("top")) + $(".page-popup .bt-component").offset().top;
                          var bottom = $(".page-popup .bt-component").offset().top + $(".page-popup .bt-component").outerHeight();
                          var heightWindow = $(window).outerHeight();
                          if (wg.hasClass("top")) {
                            if (wg.attr("bt-type") === "blockColumnOnly" || wg.attr("bt-type") === "blockList") {
                              wg.css({"top": top + "px", "left": "unset"});
                            } else {
                              wg.css({"left": (left + leftBody) + "px", "top": top + "px"});
                            }
                          } else {
                            if (bottom > heightWindow) {
                              top = "unset";
                            } else {
                              top = (bottom - parseFloat(wg.css("bottom")) - parseFloat(wg.css("height"))) + "px";
                            }
                            if (wg.attr("bt-type") === "blockColumnOnly" || wg.attr("bt-type") === "blockList") {
                              wg.css({"top": top, "left": "unset"});
                            } else {
                              wg.css({"left": (left + leftBody) + "px", "top": top});
                            }
                          }
                        } else {
                            if(wg.hasClass("bottom")) {
                              wg.css({"top":"unset"});
                            }
                        }
                      } 
                  },
                  checkActiveApp: function() {
                    var thisVue = this;
                    $.ajax({
                      url: "https://check.appon.vn/v1/public/check_upgrade_app?id=" + thisVue.idapp+"&v=4&ip="+thisVue.uidUser,
                      method: "GET",
                      success: function(data) {
                        thisVue.uidUser = data.data.uid;
                        localStorage.setItem("ipA", data.data.uid);
                        if (data && data.data && data.data.status) {
                          $("#bu-watermark").hide();
                        } else {
                          $("#bu-watermark").show();
                        }
                      }, error: function(data) {
                        $("#bu-watermark").show();
                      }
                    });
                  },
                  custom_method: function(val) {
                    var fun = val + "();";
                    eval(fun);
                  },
                  getDataModelValue: function(dataSL) {
                    var value;
                    value = this.gm(dataSL.nameTab, dataSL.keySelect, dataSL.indexKey);
                    return value;
                  },
                  getDataModelBu: function(next) {
                    var thisVue = this;
                      $.ajax({
                        url: "https://api.appon.vn/v1/public/data-app_read_public",
                        method: "POST",
                        data: {page_use: '6a16d652e81b18848682267f'},
                        success: function(dataRes) {
                          try {
                            var data = localStorage.getItem("botup-model"); 
                            if (data && data.search("bu_appID") == -1) {
                              data = JSON.parse(thisVue.budcodedata(localStorage.getItem("botup-model")));
                              if (data.bu_appID != '6a16d652e81b18848682267f') {
                                thisVue.dataModelBU = $.extend(true, [], dataRes.data[0].data.data);
                                thisVue.timeupdate = new Date().getTime();
                                data["dataModelBU"] = $.extend(true, [], thisVue.dataModelBU);
                                data.bu_appID = '6a16d652e81b18848682267f';
                                localStorage.setItem("botup-model", thisVue.buecodedata(JSON.stringify(data)));
                              }else {
                                if (data["dataModelBU"]) {
  
                                  thisVue.dataModelBU = $.extend(true, dataRes.data[0].data.data, data["dataModelBU"]);
                                  data["dataModelBU"] = $.extend(true, [], thisVue.dataModelBU);
                                  localStorage.setItem("botup-model", thisVue.buecodedata(JSON.stringify(data)));
                                } else {
                                  thisVue.dataModelBU = dataRes.data[0].data.data;
                                  thisVue.timeupdate = new Date().getTime();
                                  data["dataModelBU"] = $.extend(true, [], thisVue.dataModelBU);
                                  localStorage.setItem("botup-model", thisVue.buecodedata(JSON.stringify(data)));
                                }
                              }
                            } else {
                              data = {};
                              data.bu_appID = '6a16d652e81b18848682267f';
                              if (dataRes.data.length > 0) {
                                thisVue.dataModelBU = $.extend(true, [], dataRes.data[0].data.data);
                              } else {
                                thisVue.dataModelBU = [];
                              }
                              thisVue.timeupdate = new Date().getTime();
                              data["dataModelBU"] = $.extend(true, [], thisVue.dataModelBU);
                              localStorage.setItem("botup-model", thisVue.buecodedata(JSON.stringify(data)));
                            }
                            next();
                          } catch (err) {
                            localStorage.removeItem("botup-model");
                            window.location.reload();
                            next();
                          }
                        },
                        error: function(err) {
                          localStorage.removeItem("botup-model");
                          window.location.reload();
                          next();
                        }
                      });
                  },
                  buecodedata: function(data) {
                    var string = '';
                    try {
                      var codedata = window.btoa(unescape(encodeURIComponent(data)));
                      var part = codedata.slice(10, 18);
                      for(let i = 0; i < codedata.length; i++) {
                        string+= codedata[i];
                        if (i === 13 || i === codedata.length - 13) {
                          string+=part;
                        }
                      }
                    } catch(e) {
                      
                    }
                    return string;
                  },
                  budcodedata: function(data) {
                    var codedata = "";
                    try{
                      codedata = data.slice(0, 14) + data.slice(22, data.length - 20) + data.slice(data.length - 12, data.length);
                      codedata = decodeURIComponent(escape(window.atob(codedata)));
                    } catch(e) {
  
                    }
                    return codedata;
                  },
                  getDataModel: function(nametab, namekey, indexkey) {
                    return this.gm(nametab, namekey, indexkey);
                  },
                  gm: function(nametab, namekey, indexkey) {
                    var value;
                    if (!namekey && !indexkey && !nametab) {
                      return value;
                    }
                    if (nametab && !namekey && !indexkey) {
                      value = this.dataModelBU.find(e => e.name == nametab);
                      return value.data;
                    }
                    if (nametab && namekey && !indexkey && (indexkey != 0 || indexkey != '0')) {
                      value = [];
                      var data = this.dataModelBU.find(e => e.name == nametab);
                      for (var i = 0; i < data.data.length; i++) {
                        value.push(data.data[i][namekey]);
                      }
                      return value;
                    }
                    var data = this.dataModelBU.find(e => e.name == nametab);
                    if (data.data[indexkey]) {
                      value = data.data[indexkey][namekey];
                    }
                    return value;
                    
                  },
                  setDataModel: function(nametab, namekey, indexkey, value) {
                    this.sm(nametab, namekey, indexkey, value);
                  },
                  sm: function(nametab, namekey, indexkey, value) {
                    var thisVue = this;
                    try{
                      if (typeof indexkey == "string") {
                        indexkey.trim();
                      }
                      if ((indexkey && indexkey.length > 0) || (namekey && indexkey === 0)) {
                        indexkey = parseFloat(indexkey);
                        thisVue.dataModelBU.find(function(e) {
                          if (e.name == nametab) {
                            e.data[indexkey][namekey] = value;
                          }
                        });
                      } else {
                        if (nametab && namekey) {
                          if (Array.isArray(value)) {
                            var dataTab = thisVue.dataModelBU.find((e) => e.name == nametab);
                            var leng = value.length;
                            if (value.length < dataTab.data.length) {
                              leng = dataTab.data.length;
                            }
                            for(var i = 0; i < leng; i++) {
                              if (dataTab.data[i]) {
                                dataTab.data[i][namekey] = value[i] || "";
                              } else {
                                var arrkey = Object.keys(dataTab.data[i-1]);
                                var item = {};
                                for( var j = 0; j < arrkey.length; j++) {
                                  if (arrkey[j] == namekey) {
                                    eval("item."+arrkey[j]+" = value[i]");
                                    item[arrkey[j]] = value[i];
                                  } else {
                                    eval("item."+arrkey[j]+" = ''");
                                  }
                                }
                                dataTab.data[i] = item;
                              }
                            }
                            thisVue.dataModelBU.find(function(e) {
                              if (e.name === nametab) {
                                if (dataTab && dataTab.data) {
                                  e.data = $.extend(true, [], dataTab.data);
                                } else {
                                  e.data = $.extend(true, [], dataTab.data);
                                }
                              }
                            });
                          } else {
                            thisVue.dataModelBU.find(function(e) {
                              if (e.name == nametab) {
                                if (e.data[0]) {
                                  for(var i = 0; i < e.data.length; i++) {
                                    e.data[i][namekey] = null;
                                  }
                                } else {
                                  eval("e.data[0] = {"+namekey+": value};");
                                }
                              }
                            });
                          }
                        } else {
                          if (nametab) {
                            thisVue.dataModelBU.find(function(e) {
                              if (e.name == nametab) {
                                if (Array.isArray(value)) {
                                  e.data = $.extend(true, [], value);
                                } else {
                                  e.data = [];
                                  e.data[0] = value;
                                }
                              }
                            });
                          }
                        }
                      }
                      
                      var data = localStorage.getItem("botup-model");
                      if (data) {
                        data = JSON.parse(thisVue.budcodedata(localStorage.getItem("botup-model")));
                      } else {
                        data = {};
                      }
                      data["dataModelBU"] = $.extend(true, [], thisVue.dataModelBU);
                      localStorage.setItem("botup-model", thisVue.buecodedata(JSON.stringify(data)));
                      thisVue.timeupdate = new Date().getTime();
                    } catch(e) {
                      console.log(e);
                    };
                  },
                  checkradioChangeValue: function(event, val) {
                    var thisVue = this;
                    var modelSet;
                    var value = $(event.target).attr("data-value");
                    var elemTarget = $(event.target).parent().find("input");
                    var name = elemTarget.attr("data-name") + "radio";
                    if (this.atou(val) && this.atou(val) != undefined && this.atou(val) != "undefined") {
                      modelSet = JSON.parse(this.atou(val));
                    }
                    if (!value) {
                      value = $(event.target).parent().find("input").val();
                      elemTarget = $(event.target).parent().find("input");
                    }
                    thisVue[name] = value;
                    if (modelSet) {
                      this.sm(modelSet.nameTab, modelSet.keySelect, modelSet.indexKey, thisVue[name]);
                    }
                  },
                  checkboxChangeValue: function(event, val) {
                    event.preventDefault();
                    var thisVue = this;
                    var elemTarget = $(event.target).parent().find("input");
                    var name = elemTarget.attr("data-name") + "checkbox";
                    var value = elemTarget.attr("data-value");
                    var modelSet;
                    if (this.atou(val) && this.atou(val) != undefined && this.atou(val) != "undefined") {
                      modelSet = JSON.parse(this.atou(val));
                    }
                    if (modelSet) {
                      var index = thisVue[name].indexOf(value);
                      if (index >= 0) {
                        elemTarget.removeClass("checked");
                        thisVue[name].splice(index,1);
                      } else {
                        elemTarget.addClass("checked");
                        thisVue[name].push(value);
                      }
                      this.sm(modelSet.nameTab, modelSet.keySelect, modelSet.indexKey, thisVue[name]);
                    }
                  },
                  responsive: function() {
                    
                  },
                  changeValueSelectOption: function(event,val) {
                    var thisVue = this;
                    if (thisVue.atou(val) && thisVue.atou(val) != undefined && thisVue.atou(val) != "undefined") {
                      var value = JSON.parse(thisVue.atou(val));
                      var id = $(event.target).attr("id").replace("select-bt-", "");
                      thisVue.sm(value.nameTab, value.keySelect, value.indexKey, thisVue["modelsl"+id]);
                    }
                  },
                  addModelDefault: function() {
                    this.createDataCheckbox();
                    this.createDataSelectBox();
                  },
                  closeLBox: function(ev, id) {
                    ev.stopPropagation();
                    ev.preventDefault();
                    if ($(ev.target).hasClass("block-lightbox") || $(ev.target).hasClass("close-light-box")) {
                      $("#"+id).hide();
                    }
                  },
                  createDataCheckbox: function() {
                    var thisVue = this;
                    var wgCheck = $('.block-widget[bt-type="blockCheckbox"] > input');
                    if (wgCheck && wgCheck.length > 0) {
                      wgCheck.each(function() {
                        var name = $(this).attr("data-name") + 'checkbox';
                        if(!thisVue[name]) {
                          thisVue[name] = [];
                        }
                      })
                    }
                    var wgRadio = $('.block-widget[bt-type="blockRadio"] > input');
                    if (wgRadio && wgRadio.length > 0) {
                      wgRadio.each(function() {
                        var nameR = $(this).attr("data-name") + 'radio';
                        if(!thisVue[nameR]) {
                          thisVue[nameR] = "";
                        }
                      })
                    }
                  },
                  createDataSelectBox: function() {
                    var wgSl = $('.block-widget[bt-type="blockSelect"]');
                    var thisVue = this;
                    if (wgSl && wgSl.length > 0) {
                      wgSl.each(function() {
                        var id = $(this).attr("data-id").replace("bt-", "");
                        var value = $(this).find(".value-default-sl").attr("value");
                        var valuesm = $(this).attr("data-sm");
                        if (thisVue.atou(valuesm) && thisVue.atou(valuesm) != undefined && thisVue.atou(valuesm) != "undefined") {
                          valuesm = JSON.parse(thisVue.atou(valuesm));
                          thisVue.sm(valuesm.nameTab, valuesm.keySelect, valuesm.indexKey, value);
                        }
                        thisVue["modelsl"+id] = value;
                        $(this).find("select").val(value);
                      });
                    }
                  },
                  runCountdown: function(id, data, action) {
                    var thisVue = this;
                    var dataCount = JSON.parse(this.atou(data));
                    var dataAction = false;
                    if (this.atou(action) && this.atou(action) != undefined && this.atou(action) != "undefined") {
                      dataAction = JSON.parse(this.atou(action));
                    }
                      var dataDate;
                      var dateToday = new Date().getTime();
                      if (dataCount && dataCount.typeTime && dataCount.typeTime == 1) {
                        var dateend = new Date(dataCount.timeEnd).getTime();
                        dataDate = Math.floor((dateend - dateToday)/1000);
                      } else {
                        dataDate = Math.floor(parseFloat(dataCount.timeDay))*(24*60*60) + parseFloat(dataCount.timeHour)*(60*60) + parseFloat(dataCount.timeMin)*60 + parseFloat(dataCount.timeSec);
                      }
                      var dataValue = {
                        day: 0,
                        hour: 0,
                        min: 0,
                        sec: 0
                      };
                    var runC = setInterval(function() {
                      if (dataDate > 0) {
                        dataValue.day = Math.floor(dataDate/(24*60*60));
                        dataValue.hour = Math.floor(dataDate/(60*60)) - dataValue.day*24;
                        dataValue.min = Math.floor(dataDate/60) - dataValue.day*(24*60) - dataValue.hour*60;
                        dataValue.sec = dataDate%60;
                        if (dataValue.day < 10) {
                          dataValue.day = "0"+dataValue.day;
                        }
                        if (dataValue.hour < 10) {
                          dataValue.hour = "0"+dataValue.hour;
                        }
                        if (dataValue.min < 10) {
                          dataValue.min = "0"+dataValue.min;
                        }
                        if (dataValue.sec < 10) {
                          dataValue.sec = "0"+dataValue.sec;
                        }
                        dataDate--;
                      } else {
                        dataValue = {day: "00",hour: "00",min: "00",sec: "00"};
                        clearInterval(runC);
                        if (dataAction) {
                          async.eachSeries(dataAction, thisVue.runAction, function(err, result) {
                          });
                        }
                      }
                      $("."+id+" .item-count.count-day .value-count").text(dataValue.day);
                      $("."+id+" .item-count.count-hour .value-count").text(dataValue.hour);
                      $("."+id+" .item-count.count-min .value-count").text(dataValue.min);
                      $("."+id+" .item-count.count-sec .value-count").text(dataValue.sec);
  
                    }, 1000);
                    
                  },
                  checkCountdown: function() {
                    var thisVue = this;
                    var wg = $(".page-popup .block-widget.block-countdown");
                    if (wg && wg.length > 0) {
                      wg.each(function() {
                        var id = $(this).attr("data-id");
                        var dataTime = $(this).find(".block-content").attr("data-time");
                        var dataAction = $(this).find(".block-content").attr("data-action");
                        thisVue.runCountdown(id, dataTime, dataAction);
                      })
                    }
                  },
                  formatCurency: function(val) {
                    var dataFormat = "";
                    if (this.atou(val) && this.atou(val) != undefined && this.atou(val) != "undefined") {
                      dataFormat = JSON.parse(this.atou(val));
                      var value = this.gm(dataFormat.nametab, dataFormat.namekey, dataFormat.indexkey)
                      if (typeof value == "number") {
                        var formatter = new Intl.NumberFormat('de-DE', {
                          style: 'currency',
                          minimumFractionDigits: 0,
                          currency: dataFormat.typeCurency
                        });
                        this.sm(dataFormat.nametab, dataFormat.namekey, dataFormat.indexkey, formatter.format(value));
                      }
                    }
                  }
              },
              created: function() {
                
              },
              mounted: function () {
                $(".page-popup .wapper").scrollTop(0);
                $model = this;
                var thisVue = this;
                thisVue.uidUser = localStorage.getItem("ipA");
                var data = localStorage.getItem("botup-model"); 
                if (data && data.length > 0) {
                  data = JSON.parse(thisVue.budcodedata(localStorage.getItem("botup-model")));
                  thisVue.dataModelBU = $.extend(true, [], data.dataModelBU);
                  thisVue.mid = data.mid;
                  thisVue.timeupdate = new Date().getTime(); 
                } else {
                  this.getDataModelBu(function() {
                    data = JSON.parse(thisVue.budcodedata(localStorage.getItem("botup-model")));
                    thisVue.dataModelBU = $.extend(true, [], data.dataModelBU);
                    thisVue.mid = data.mid;
                    thisVue.timeupdate = new Date().getTime(); 
                  })
                }
                
                setTimeout(function() {
                    thisVue.checkCountdown();
                    thisVue.addModelDefault();
                    var wgSticky = $(".page-popup .sticky-bt");
                    if (wgSticky && wgSticky.length > 0) {
                      wgSticky.each(function() {
                        if ($(this).hasClass("top") || $(this).hasClass("bottom")) {
                          thisVue.resetSticky($(this));
                        } else {
                          $(this).removeClass("sticky-bt").removeClass("none");
                        }
                      })
                    }
                    $(".wapper").css({"overflow": "hidden!important"});
                    $(".page-popup .wapper").css({"overflow-y": "auto!important"});
                    
                  }, 300);
                  
                  setTimeout(function() {
                    $(".page-popup .bt-component").on("click",function(event) {
                      if($(event.target).hasClass("bt-component")) {
                        thisVue.actionPage("home");
                      }
                    });
                    var contentsheet = $(".page-popup .wapper");
                    if (!contentsheet || contentsheet.length == 0) {
                      contentsheet = $(".bt-component .wapper");
                    }
                    var scroll = contentsheet.scrollTop();
                    var draggsheet = false;
                    var down = false;
                    var yStart = 0;
                    var tStart = contentsheet.offset().top;
                    contentsheet.off("mousedown").on("mousedown", function(event) {
                      scroll = contentsheet.scrollTop();
                      yStart = event.clientY;
                      down = true;
                        $("body").off("mousemove").on("mousemove", function(event1) {
                          if (down == true && (event1.clientY - yStart > 5 || event1.clientY - yStart < -5)) {
                            draggsheet = true;
                          }
                            if(draggsheet && scroll == 0) {
                              $(".sticky-bt").hide();
                              var scale = yStart/event1.clientY + 0.1;
                              if(scale < 0.7) {scale = 0.7;}
                              if(scale > 1) {scale = 1;}
                              contentsheet.css({"transform": "scale("+scale+")"});
                            }
                        });
                        $("body").off("mouseup").on("mouseup", function(event2) {
                          $(".sticky-bt").show();
                          down = false;
                            if(draggsheet) {
                                draggsheet = false;
                                var scale = yStart/event2.clientY;
                                if(scroll == 0 && scale < 0.7) {
                                  contentsheet.animate({opacity: 0})
                                  setTimeout(function() {
                                    thisVue.actionPage("home");
                                  }, 300);
                                } else {
                                 
                                  contentsheet.attr("style", "");
                                }
                            }        
                        })
                    });
                    contentsheet.off("touchstart").on("touchstart", function(event) {
                        down = true;
                        yStart = event.changedTouches[0].clientY;
                        scroll = contentsheet.scrollTop();
                        $("body").off("touchmove").on("touchmove", function(event1) {
                          $(".sticky-bt").hide();
                          if (down == true && (event1.changedTouches[0].clientY - yStart > 5 || event1.changedTouches[0].clientY - yStart < -5)) {
                            draggsheet = true;
                          }
                            if(draggsheet && scroll == 0) {
                              
                              var scale = yStart/event1.changedTouches[0].clientY + 0.1;
                              if(scale < 0.7) {scale = 0.7;}
                              if(scale > 1) {scale = 1;}
                              contentsheet.css({"transform": "scale("+scale+")"})
                            }
                        });
                        $("body").off("touchend").on("touchend", function(event2) {
                          $(".sticky-bt").show();
                          down = false;
                            if(draggsheet) {
                                var scale = yStart/event2.changedTouches[0].clientY;
                                draggsheet = false;
                                if(scroll == 0 && scale < 0.7) {
                                  contentsheet.animate({opacity: 0})
                                  setTimeout(function() {
                                    thisVue.actionPage("home");
                                  }, 300);
                                } else {
                                  contentsheet.attr("style", "");
                                }
                            }
                        })
                    });
                  },1000);
              }
          }</script>